import React, {useEffect, useState} from "react";
import CoinsCart from "./CoinsCart";
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import MySlick from "./MySlick";
import { GroupCard } from "./GroupCard";


export default function  TopGainers(){

    const [isLoading,setIsLoading] = useState(true)
    const [topGainSym,setTopGainSym] = useState([])
    const [newCoin,setNewCoin] = useState([])
    const [levCoin,setLevCoin] = useState([])
    const isSmall = useMediaQuery('(max-width: 768px)')


        function requestHakdleGetCoin() {
               axios.get('https://api.sinatether.com/Auth/GetTopGainers').then((res)=>{
            if (res.status == 200){
                setTopGainSym(res.data['TopGainers'])
                setNewCoin(res.data['new_coins'])
                setLevCoin(res.data['lev'])


                setIsLoading(false)
            }
        }).catch((error)=>{
                            if (error){
                                console.log(error)
                            }
                    })

        }



    useEffect(()=>{

        const resultInterval = () => {
            requestHakdleGetCoin()
            setTimeout(resultInterval, 200000);



        };
        resultInterval();





    },[])


    return(
        <div className={`fjsflex53535 djnsudgtrfddd dliscard4242 mlr-22 mr-0 pading22btm kjdpadingjtop ${isLoading? 'just-center' : ''}`}>
             {isLoading ?

<div className={'text-center'}>
    <div className={'text-center '}>


        <img src={'./img-camp/loading.svg'}/>


        </div>

</div>

:
<>

        <GroupCard  title={"پرسود ترین ها"} syms={topGainSym}/>

        <GroupCard title={"جدید اضافه شده"} syms={newCoin}/>
        <GroupCard  title={"ارز های لوریج دار"} syms={levCoin}/>


        </>

             }





        </div>                   
                    
                       
    )
}